import { Component, OnInit } from '@angular/core';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';
import moment from 'moment';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-confirmation-pending',
  templateUrl: './confirmation-pending.component.html',
  styleUrls: ['./confirmation-pending.component.css']
})
export class ConfirmationPendingComponent implements OnInit {


    currentPage: number = 1;
    statusArray:any=[]
     AllocationFlag:any=false
     itemsPerPage: number = 25;
     totalItems: number =0
     tableSize: number[] = [5, 10, 20, 50, 100];
     pagingConfig: any = {}
     pageNo: any;
     size: any;
     searchQuery:any=''
     reminderCases:any=[]
     currentCount:any=0
     total:any=0
     token:any
     storedData:any
     sortOrder: 'asc' | 'desc' = 'asc';
     sortField: string = ''; // Tra
     currentSortColumn:any=''
     dropdownSettings:any
     staffDetails:any=[]
     cases = [
      // { name: 'All Cases', count: 0 ,item_id:'All',item_text:'All'},
      // { name: 'Fresh Cases', count: 0 ,item_id:'New case',item_text:'New case'},
      // { name: 'Under Validation', count:0 ,item_id:'Under Validation',item_text:'Under Validation'},
      // { name: 'Verified Cases', count: 0 ,item_id:'Verified',item_text:'Verified'},
      { name: 'Interested', count: 0,item_id:'Interested',item_text:'Interested'},
      { name: 'Meeting Case', count: 0,item_id:'Field Visit',item_text:'Field Visit' },
      { name: 'Under TeleCall', count: 0 ,item_id:'Under TeleCall',item_text:'Under TeleCall'},

    ];
    selectedStatuses:any=this.cases

     constructor(private loginService:LoginService,private router:Router) { this.pagingConfig = {
       itemsPerPage: this.itemsPerPage,
       currentPage: this.currentPage,
       totalItems: this.totalItems
     } }
   
     ngOnInit(): void {
       this.token = localStorage.getItem('token');
       this.storedData= JSON.parse(localStorage.getItem("user") || '{}');
      //  this.listStaffs()
      this.listReminderCases()
      this.PushStatus()
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'item_id',
        textField: 'item_text',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true,
        appendToBody: true, // Ensures dropdown appears above everything
  
      };
     }
     onTableSizeChange(event: any): void {
       this.pagingConfig.itemsPerPage = event.target.value;
       this.pagingConfig.currentPage = 1;
       this.size = event.target.value
       this.listReminderCases()
   
     }
     onTableDataChange(event: any) {
       this.pagingConfig.currentPage = event;
       this.listReminderCases()
     }
     listReminderCases(){
       
   
       let req={
         searchKey:this.searchQuery,
   
         page:this.pagingConfig.currentPage,
         limit:this.pagingConfig.itemsPerPage
       }
   
   
       let body={
        remarks:"Confirmation Pending",
         status:this.statusArray,
         userType:this.storedData.userType[0].userType,
         userTypeId:this.storedData.userType[0]._id
       }
   
   
         this.loginService.listReminderCases(this.token,req,body)
                   .subscribe((response: any) => {
                     if (response.status === 1) {
                            this.reminderCases=response.data
                            this.pagingConfig.totalItems =response.totalCount;
                            this.currentCount=response.data.length
                           this.total=response.totalCount
                     }})
     }
    //  ClientDetail(flag:any,obj:any){
    //    obj.flag=flag
    //    obj.type='reminder'
    //    localStorage.setItem('Work',JSON.stringify(obj))
    //    this.router.navigate(["/view-work"])
   
    //  }

   ClientDetail(flag: any, obj: any) {
    obj.flag = flag;
  obj.type='reminder'
     obj.productId=obj._id

    localStorage.setItem('Work', JSON.stringify(obj));
  
  
    if (this.storedData.userType[0].userType=='Backend Staff' || this.storedData.userType[0].userType=='Tele Caller') {
     let data={
      userId:this.storedData._id,

     }
    
      this.loginService.checkPunchStatus(this.token,data).
      subscribe((response: any) => {
        if (response.result.length>0) {
          this.router.navigate(["/view-work"])
        } else {
          // alert('Please punch in before proceeding.');
          Swal.fire({
            title: 'UnAuthorized',
            text: "Please Punch In!!!!",
            icon: 'warning',
                  })
        }
      }
    )
    } else {
      this.router.navigate(["/view-work"])
    }
  }


     format(date:any){
      return moment(date).format(`DD-MM-YYYY \n \nHH:mma`);
     
     }


       copyText(text: string) {
           // navigator.clipboard.writeText(text);
           // alert(`Copied: ${text}`);
     
            navigator.clipboard.writeText(text).then(
             () => {
                 const Toast = Swal.mixin({
                       toast: true,
                       position: "center",
                       showConfirmButton: false,
                       timer: 1500,
                       timerProgressBar: true,
                       didOpen: (toast) => {
                         toast.onmouseenter = Swal.stopTimer;
                         toast.onmouseleave = Swal.resumeTimer;
                       }
                     });
                     Toast.fire({
                       icon: "success",
                       title: "Code copied to clipboard"
                     });
     
             },
             (err) => {
               console.error('Could not copy text: ', err);
             }
           );
     }

     sortTable(column: string): void {
      this.sortField=column
       if (this.currentSortColumn === column) {
         // Toggle the sort order if the column is already sorted
         this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
       } else {
         // Set the column to the current sort column and default to ascending
         this.currentSortColumn = column;
         this.sortOrder = 'asc';
       }
     
       this.reminderCases.sort((a: any, b: any) => {
         let valueA = this.getValueByPath(a, column);
         let valueB = this.getValueByPath(b, column);
     
         // Handle null or undefined values
         if (valueA == null) return this.sortOrder === 'asc' ? 1 : -1;
         if (valueB == null) return this.sortOrder === 'asc' ? -1 : 1;
     
         // Attempt to parse dates
         const dateA = this.parseCustomDate(valueA);
         const dateB = this.parseCustomDate(valueB);
     
         if (dateA && dateB) {
           // Compare as dates
           if (dateA < dateB) return this.sortOrder === 'asc' ? -1 : 1;
           if (dateA > dateB) return this.sortOrder === 'asc' ? 1 : -1;
           return 0;
         }
     
         // Compare as numbers if both are numeric
         if (!isNaN(valueA) && !isNaN(valueB)) {
           valueA = Number(valueA);
           valueB = Number(valueB);
           return this.sortOrder === 'asc' ? valueA - valueB : valueB - valueA;
         }
     
         // Compare as strings (case insensitive)
         valueA = String(valueA).toLowerCase();
         valueB = String(valueB).toLowerCase();
         if (valueA < valueB) return this.sortOrder === 'asc' ? -1 : 1;
         if (valueA > valueB) return this.sortOrder === 'asc' ? 1 : -1;
         return 0;
       });
     }

     parseCustomDate(dateString: string): Date | null {
      // Match DD/MM/YYYY
      const ddmmyyyyRegex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      const ddmmyyyyMatch = dateString.match(ddmmyyyyRegex);
      if (ddmmyyyyMatch) {
        const [_, day, month, year] = ddmmyyyyMatch.map(Number);
        return new Date(year, month - 1, day);
      }
    
      // Match YYYY-MM-DD
      const yyyymmddRegex = /^(\d{4})-(\d{2})-(\d{2})$/;
      const yyyymmddMatch = dateString.match(yyyymmddRegex);
      if (yyyymmddMatch) {
        const [_, year, month, day] = yyyymmddMatch.map(Number);
        return new Date(year, month - 1, day);
      }
    
      return null; // Return null if no valid date format is detected
    }
    
    // Helper function to get nested values by path
    getValueByPath(obj: any, path: string): any {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }
     formatDate(isoDate: string): string {
       if(isoDate){
         const date = new Date(isoDate);
         const day = String(date.getDate()).padStart(2, '0');
         const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
         const year = date.getFullYear();
         return `${day}/${month}/${year}`;
       }else{
         return ''
       }
     
     }
   
     listStaffs(){

      this.loginService.listStaffs(this.token)
    .subscribe((response: any) => {
      if (response.status === 1) {
              this.staffDetails =response.data

      }})
   
     


    }

   onInitiatedByChange(event:any){
      let req={
        searchKey:this.searchQuery,
        page:this.pagingConfig.currentPage,
        limit:this.pagingConfig.itemsPerPage
      }


      let body={
        // status:"All",
        // userType:this.storedData.userType[0].userType,
        // products:this.storedData.products
        initiatedBy:event.target.value
      }
    
                  this.loginService.listClientsById(this.token,req,body)
                             .subscribe((response: any) => {
                              this.reminderCases=response.data
                              this.pagingConfig.totalItems = response.totalCount;
                              this.currentCount=response.count
                              this. total=response.totalCount

                             })
    }
    getStatusClass(status: string): string {
      switch (status) {
        case 'New case':
          return 'status-new-case';
        case 'Under Validation':
          return 'status-under-validation';
        case 'Verified':
          return 'status-verified';
        case 'Under Telecall':
          return 'status-under-telecall';
        case 'Interested':
          return 'status-interested';
        case 'Not Interested':
          return 'status-not-interested';
        case 'Client Enrolled':
          return 'status-client-enrolled';
        case 'Field Visit':
          return 'status-field-visit';
        default:
          return 'status-default';
      }
    }
    reset(each:any){

   Swal.fire({
        title: 'Reset File?',
        text: "You won't be able to revert this!",
        icon: 'warning',
       
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        preConfirm: () => {
   this.loginService.resetReminder(this.token,each._id)
      .subscribe((response: any) => {
      this.listReminderCases()

      })
        }})
      // this.loginService.listClientsById(this.token,body)
      // .subscribe((response: any) => {
      

      // })
    }
    PushStatus() {
      // console.log(event, this.selectedStatuses);
    
      // Reset statusArray to avoid duplicates
      this.statusArray = this.selectedStatuses
        .map((status: any) => status.item_id) // Extract item_id
        .filter((id:any, index:any, self:any) => id && self.indexOf(id) === index); // Remove duplicates
    
      this.listReminderCases();
    }


}
